import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface useKilnDrillingSettingsQueryParams {
  plantUpmId: string
  kilnUpmId: string
}

export const useKilnDrillingSettingsQuery = ({
  plantUpmId,
  kilnUpmId
}: useKilnDrillingSettingsQueryParams) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'drillingSettings',
    params: [{plantUpmId, kilnUpmId}],
    retry: false,
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useKilnDrillingSettingsQuery')
        .extras({errorDetails, plantUpmId, kilnUpmId})
        .error('Error occurred while fetching kiln drilling settings')

      spawnErrorToast(t('error.kilnDrillingSettingsQuery'))

      return false
    }
  })
}
